<template>
    <ion-page>
        <standard-header title="Welcome" />
        <ion-content :fullscreen="true">
            <pull-down-refresh :callback="refresh"/>
            <ion-grid>
                <ion-row>
                    <ion-col size="4">
                        <ion-button color="light" expand="block" class="large" size="large" :disabled="!can('warehouse.stack')" @click="$router.push({name: 'warehouse.pick.items.index'})">
                            <div><ion-icon :icon="handRightOutline"></ion-icon>Pick</div>
                        </ion-button>
                    </ion-col>
                    <ion-col size="4">
                        <ion-button color="light" expand="block" class="large" size="large" :disabled="!can('warehouse.stack')" @click="$router.push({name: 'warehouse.move.items.index'})">
                            <div><ion-icon :icon="moveOutline"></ion-icon>Move</div>
                        </ion-button>
                    </ion-col>
                    <ion-col size="4">
                        <ion-button color="light" expand="block" class="large" size="large" :disabled="!can('warehouse.stack')" @click="$router.push({name: 'warehouse.returns.locations'})">
                            <div><ion-icon :icon="refreshCircleOutline"></ion-icon>Return</div>
                        </ion-button>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <ion-badge v-show="stats.picks > 0">{{ stats.picks }}</ion-badge>
                        <ion-button color="light" expand="block" class="large" size="large" @click="$router.push({name: 'picks.mine'})" :disabled="!can('warehouse.pick')">
                            <div><ion-icon :icon="layersOutline"></ion-icon>Picking</div>
                        </ion-button>
                    </ion-col>
                    <ion-col>
                        <ion-badge v-show="stats.checks > 0">{{ stats.checks }}</ion-badge>
                        <ion-button color="light" expand="block" class="large" size="large" @click="$router.push({name: 'checks.all'})" :disabled="!can('warehouse.check')">
                            <div><ion-icon :icon="checkboxOutline"></ion-icon>Checking</div>
                        </ion-button>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <ion-button color="light" expand="block" class="large" size="large" :disabled="!can('warehouse.pack')" @click="$router.push({name: 'packs.mine'})">
                            <div><ion-icon :icon="cubeOutline"></ion-icon>Packing</div>
                        </ion-button>
                    </ion-col>
                    <ion-col>
                        <ion-button color="light" expand="block" class="large" size="large" :disabled="!can('warehouse.receive')" @click="$router.push({name: 'warehouse.receive.create'})">
                            <div><ion-icon :icon="downloadOutline"></ion-icon>Goods In</div>
                        </ion-button>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <ion-badge v-show="stats.stacks > 0">{{ stats.stacks }}</ion-badge>
                        <ion-button color="light" expand="block" class="large" size="large" :disabled="!can('warehouse.stack')" @click="$router.push({name: 'warehouse.stack.index'})">
                            <div><ion-icon :icon="locateOutline"></ion-icon>Stack</div>
                        </ion-button>
                    </ion-col>
                    <ion-col>
                        <ion-badge v-show="stats.takes > 0">{{ stats.takes }}</ion-badge>
                        <ion-button color="light" expand="block" class="large" size="large" @click="$router.push({name: 'stocktakes.mine'})" :disabled="!can('warehouse.stocktake')">
                            <div><ion-icon :icon="pieChartOutline"></ion-icon>Stock</div>
                        </ion-button>
                    </ion-col>

                </ion-row>
                <ion-row>
                    <ion-col>
                        <ion-button color="light" expand="block" class="large" size="large" @click="$router.push({name: 'warehouse.items.index'})" :disabled="!can('warehouse.stack')">
                            <div><ion-icon :icon="gridOutline" />Inventory</div>
                        </ion-button>
                    </ion-col>
                    <ion-col>
                        <ion-button color="light" expand="block" class="large" size="large" @click="$router.push({name: 'warehouse.uplifts.index'})" :disabled="!can('warehouse.stack')" >
                            <div><ion-icon :icon="refreshCircleOutline" />Returns</div>
                        </ion-button>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <ion-button color="light" expand="block" class="large" size="large" @click="$router.push({name: 'lists.all'})" :disabled="!can('shipments.store')">
                            <div><ion-icon :icon="cartOutline" />Lists</div>
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
import {IonPage, IonContent} from '@ionic/vue';
import {IonButton, IonIcon, IonBadge} from '@ionic/vue';
import {IonGrid, IonRow, IonCol} from '@ionic/vue';
import {cartOutline, gridOutline, alertCircleOutline, layersOutline, checkboxOutline, cubeOutline, pieChartOutline, refreshCircleOutline, readerOutline, settings, menu, downloadOutline, locateOutline, moveOutline, handRightOutline} from 'ionicons/icons';
import StandardHeader from "@/components/StandardHeader.vue";
import PullDownRefresh from "@/components/PullDownRefresh.vue";
import Storage from '@/services/Storage';

export default {
    name: 'Tab1',
    inject: ['$http'],
    components: {
        PullDownRefresh,
        StandardHeader,
        IonContent, IonPage, IonBadge,
        IonButton, IonIcon, IonRow, IonGrid, IonCol,
    },
    data() {
        return {
            user: {},
            stats: {
                picks: 0,
                checks: 0,
                takes: 0
            }
        }
    },
    methods: {
        can(permission) {
            return this.user && this.user.permissions && this.user.permissions[permission];
        },
        ionViewDidEnter() {
            this.storage.get('user').then(user => {
                this.user = user;
            });
            this.refresh();
        },
        refresh(event = null) {
            this.$http.get('/api/me/stats').then(response => {
                this.stats = response.data;
            }).finally(() => {
                if (event && event.target.complete) {
                    event.target.complete();
                }
            })
        }
    },
    setup() {
        const storage = new Storage();
        return {
            storage,
            cartOutline,
            gridOutline,
            alertCircleOutline,
            layersOutline,
            checkboxOutline,
            cubeOutline,
            pieChartOutline,
            refreshCircleOutline,
            moveOutline,
            handRightOutline,
            readerOutline,
            settings,
            menu,
            downloadOutline,
            locateOutline
        }
    }
}
</script>

<style scoped>

    ion-badge {
        position: absolute;
        padding: 5px 10px;
        top: 2px;
        right: 2px;
        font-size: 150%;
        z-index: 1000;
    }

    ion-button.large {
        min-height: 150px;
    }

    ion-button div {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
    }

    ion-button ion-icon {
        font-size: 300%;
        margin-bottom: 0.2em;
    }
</style>
